let computed = require('baobab').monkey;
let { isContinueEnabled } = require('./registration');

const ERRORS_MAP = {
    passportUserAlreadyAssociated: 'Такой пользователь уже зарегистрирован',
    internalError: 'Что-то пошло не так, попробуйте еще раз'
};

module.exports = {
    /**
     * Проверяем на то что все обязательные поля заполненны и валидны
     * @param {Object} state
     */
    registerButton (state) {
        state.set(['registrationExtra', 'computed', 'registerButton', 'isEnabled'], computed(
            ['registrationExtra', 'error'],
            ['registrationExtra', 'form'],
            ['registrationExtra', 'ui', 'registerButton', 'isDisabled'],
            (error, form, isDisabled) => isContinueEnabled(error, form, isDisabled, [])
        ));
    },

    errorState (state) {
        state.set(['registrationExtra', 'computed', 'error', 'isError'], computed(
            ['registrationExtra', 'error', 'errorType'],
            (errorType) => errorType
        ));
    },

    errorMessage (state) {
        state.set(['registrationExtra', 'computed', 'error', 'text'], computed(
            ['registrationExtra', 'error', 'errorType'],
            (errorType) => ERRORS_MAP[errorType]
        ));
    },

    /**
     * Есть возможность выбрать тип пользователя (физ.лицо, юр.лицо и т.д.)
     * Сейчас юр.лица могут быть только для России и Казахстана
     * @param {Object} state
     */
    isUserTypeSelectEnabled (state) {
        state.set(['registrationExtra', 'computed', 'isUserTypeSelectEnabled'], computed(
            ['registrationExtra', 'form', 'countryId'],
            (countryId) => countryId === 1 || countryId === 4
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/auth/registration-extra.js